export const getRichTextLength = (html: string): number => {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  const plainText = tmp.textContent || tmp.innerText || '';
  return plainText.trim().length;
};

export const richTextToPlainText = (html: string): string => {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || '').trim();
};

export const isRichTextEmpty = (html: string): boolean => {
  const plainText = richTextToPlainText(html);
  return plainText.length === 0;
};

export const isSingleLineRichText = (html: string): boolean => {
  if (isRichTextEmpty(html)) {
    return true;
  }

  const tmp = document.createElement('div');
  tmp.innerHTML = html;

  if (tmp.querySelector('ul, ol, li, h1, h2, h3, h4, h5, h6, blockquote, pre')) {
    return false;
  }

  const hasExplicitLineBreak = Array.from(tmp.querySelectorAll('br')).some(
    (br) => !br.classList.contains('ProseMirror-trailingBreak')
  );
  if (hasExplicitLineBreak) {
    return false;
  }

  const paragraphs = Array.from(tmp.querySelectorAll('p')).filter((paragraph) => {
    return (paragraph.textContent || '').trim().length > 0;
  });
  if (paragraphs.length > 1) {
    return false;
  }

  const plainText = richTextToPlainText(html);
  return !plainText.includes('\n');
};
